import script from "./ForVendors.vue?vue&type=script&setup=true&lang=js"
export * from "./ForVendors.vue?vue&type=script&setup=true&lang=js"

import "./ForVendors.vue?vue&type=style&index=0&id=086afcf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-086afcf5"]])

export default __exports__